import { StatusLine } from '@/components/StatusLine.tsx';
import { m } from '@/paraglide/messages.js';

export interface SaveStatusProps {
  pending: boolean;
  failed: boolean;
}

/**
 * Says whether the last change to a settings page made it to the server.
 *
 * Only the wording lives here. Reserving the line, and keeping it reserved when
 * there is nothing to say, is StatusLine's job — every settings tab has to open
 * at the same height whether or not it has a status to report.
 */
export function SaveStatus({ pending, failed }: SaveStatusProps) {
  if (failed) return <StatusLine message={m.settings_save_failed()} tone='danger' />;
  if (pending) return <StatusLine message={m.settings_saving()} />;

  return <StatusLine />;
}
